import React from 'react';
import './LegalPage.css';

const TerminosCondiciones = () => (
    <div className="legal-page">
            <h1>Términos y Condiciones de Uso de Navi</h1>

            <h2>1. Información general</h2>
            <p>Estos Términos y Condiciones regulan el acceso, navegación y uso del sitio web de Navi, así como las condiciones aplicables a la contratación de servicios (actuales o futuros).</p>

            <h2>2. Aceptación de condiciones</h2>
            <p>Al acceder o utilizar este sitio, el usuario acepta expresamente estas condiciones. Si no está de acuerdo, debe cesar en el uso del sitio web.</p>

            <h2>3. Servicios ofrecidos</h2>
            <p>Navi ofrece servicios de consultoría y automatización tecnológica para pymes, incluyendo soluciones con inteligencia artificial, automatización de procesos y desarrollo de herramientas digitales personalizadas.</p>

            <h2>4. Acceso gratuito y de pago</h2>
            <p>Inicialmente, algunos servicios pueden ser ofrecidos de forma gratuita (por ejemplo, pruebas de 15 días). Navi se reserva el derecho de establecer precios, condiciones o retirar los servicios en cualquier momento.</p>

            <h2>5. Obligaciones del usuario</h2>
            <ul>
                    <li>Proporcionar información veraz y actualizada</li>
                    <li>No utilizar el sitio con actividades ilícitas o contrarias a la buena fe</li>
                    <li>No provocar daños al sitio web ni interferir en su funcionamiento</li>
            </ul>

            <h2>6. Contratación de servicios</h2>
            <p>La contratación de servicios de pago se realizará mediante acuerdo directo con Navi. Las condiciones específicas (precio, alcance, plazos) se establecerán contractualmente con cada cliente.</p>

            <h2>7. Exclusión de responsabilidad</h2>
            <p>Navi no garantiza que el sitio esté siempre disponible o libre de errores. El uso es bajo responsabilidad del usuario. Navi no será responsable por daños derivados del uso o imposibilidad de uso.</p>

            <h2>8. Propiedad intelectual</h2>
            <p>Todos los derechos sobre el contenido, diseño y código fuente del sitio web son de Navi o licenciantes. Queda prohibida la reproducción total o parcial sin autorización expresa.</p>

            <h2>9. Modificaciones</h2>
            <p>Navi podrá modificar en cualquier momento estos Términos y Condiciones. Las nuevas condiciones se considerarán aceptadas si el usuario continúa utilizando el sitio tras su publicación.</p>

            <h2>10. Legislación aplicable y jurisdicción</h2>
            <p>Estas condiciones se rigen por la legislación española. Para controversias, las partes se someten a los tribunales de Alicante (España).</p>
    </div>
);

export default TerminosCondiciones;
